import { ServerRoutes } from "@rinastyling/common";
import { ServerService } from "./ServerService";
import {
  ForgotPassword,
  ForgotPasswordRequest,
  GetRandomPassword,
  Login,
  Logout,
  PasswordlessLoginRequest,
  PasswordlessLoginSubmit,
  Register,
  ValidateUser
} from "@rinastyling/common";
export class AuthService extends ServerService {
  constructor() {
    super(ServerRoutes.auth);
  }
  login(loginBody: Login["request"]) {
    return this.typedFetch<Login["request"], Login["response"]>("login", {
      body: loginBody,
      method: "POST"
    });
  }
  register(registerBody: Register["request"]) {
    return this.typedFetch<Register["request"], Register["response"]>(
      "register",
      { body: registerBody, method: "POST" }
    );
  }
  validateUser() {
    return this.typedFetch<ValidateUser["request"], ValidateUser["response"]>(
      "validate-user"
    );
  }
  getRandomPassword() {
    return this.typedFetch<
      GetRandomPassword["request"],
      GetRandomPassword["response"]
    >("random-password");
  }
  forgetPasswordRequest(query: ForgotPasswordRequest["query"]) {
    return this.typedFetch<
      ForgotPasswordRequest["request"],
      ForgotPasswordRequest["response"]
    >("forgot-password", { method: "GET" }, query);
  }

  forgetPassword(body: ForgotPassword["request"]) {
    return this.typedFetch<
      ForgotPassword["request"],
      ForgotPassword["response"]
    >("forgot-password", { method: "POST", body });
  }
  passwordlessLoginRequest(body: PasswordlessLoginRequest["request"]) {
    return this.typedFetch<
      PasswordlessLoginRequest["request"],
      PasswordlessLoginRequest["response"]
    >("paswordless-login-request", { method: "POST", body });
  }
  passwordlessLoginSubmit(body: PasswordlessLoginSubmit["request"]) {
    return this.typedFetch<
      PasswordlessLoginSubmit["request"],
      PasswordlessLoginSubmit["response"]
    >("paswordless-login-submit", { method: "POST", body });
  }
  logout() {
    return this.typedFetch<Logout["request"], Logout["response"]>("logout");
  }
}
